module.exports = __webpack_public_path__ + "img/mealCart.638de45a.png";